import { useState, useEffect, useRef } from 'react';

export function useFeedbackForm({ isOpen, defaultType, resetFormState, setErrorMessage }) {
  const [type, setType] = useState('bug');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [screenshotFile, setScreenshotFile] = useState(null);
  const [screenshotPreview, setScreenshotPreview] = useState(null);

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setType(defaultType || 'bug');
      setTitle('');
      setDescription('');
      setScreenshotFile(null);
      setScreenshotPreview(null);
      resetFormState();
    }
  }, [isOpen, defaultType, resetFormState]);

  const handleTypeChange = (e, newType) => {
    if (newType) {
      setType(newType);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      setErrorMessage('Please select an image file (PNG, JPG, WebP, etc.).');
      return;
    }

    const MAX_SIZE = 10 * 1024 * 1024; // 10MB
    if (file.size > MAX_SIZE) {
      setErrorMessage('Image size exceeds 10MB. Please choose a smaller image.');
      return;
    }

    setErrorMessage('');
    setScreenshotFile(file);

    const reader = new FileReader();
    reader.onload = () => {
      setScreenshotPreview(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveScreenshot = () => {
    setScreenshotFile(null);
    setScreenshotPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return {
    type,
    title,
    setTitle,
    description,
    setDescription,
    screenshotFile,
    screenshotPreview,
    fileInputRef,
    handleTypeChange,
    handleFileChange,
    handleRemoveScreenshot,
  };
}
